export default "__VITE_ASSET__6a045447__"